import React from 'react';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './DJMVList.css';

function DJMVList({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        newDJMV,
    } = functions;

    const { DJMVListData, tableData, viniedos, settings, EnableBtn } = states;

    return (
        <div className="DJMVList-container">
            {DJMVListData.length > 0 ? (
                <>
                    <TableContainer tableData={tableData} />
                </>
            ) : (
                <h3>No tiene ninguna Declaración de Modificación de Viñedo</h3>
            )}
            {new Date(settings?.djcp_rango_inicio) <
                new Date() <
                new Date(settings?.djcp_rango_fin) && (
                <div className="DJMVList-footer">
                    <form onSubmit={handleSubmit(newDJMV)}>
                        <select {...register('myViniedo')}>
                            <option value={0}>Elegir Viñedo</option>
                            {viniedos?.map((v) => {
                                return (
                                    <option key={v.id} value={v.id}>
                                        {v.num}
                                    </option>
                                );
                            })}
                        </select>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={EnableBtn === 0}
                        >
                            Nueva DJMV
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default DJMVList;
